<template>
  <div class="preview-horizontal-product-list">
    <div class="row align-items-center pt-5 pb-5">
      <div class="col">
        <section-header :title="title" :subtitle="subtitle" class="to-fade-in-upward"/>
      </div>
      <div class="col-auto" v-if="viewAll">
        <small><router-link class="text-dark" :to="viewAll">View all</router-link></small>
      </div>
    </div>
    <div class="product-scroll-frame position-relative row">
      <div class="col-12">
        <div class="row d-block text-nowrap pb-3 product-scroll" :id="id" @mousedown="onMouseDown" @mousemove="onMouseMove" @mouseup="onMouseUp">
          <template v-for="(product, index) in products">
            <div class="col-auto d-inline-block product-item" v-if="product && product.isOnSale" :key="index">
              <product-grid-item :product="product"/>
            </div>
          </template>
        </div>
        <div class="row">
          <div class="col p-0 bg-white"><div class="bg-black percentage-scrollbar" :style="`width: ${view.scrollPercentage}%`"></div></div>
        </div>
      </div>
      <div class="btn-scroll left" @click.stop="onPrevClicked"><img src="@/assets/img/ic-arrow-left-circle.svg" alt="arrow-left"></div>
      <div class="btn-scroll right" @click.stop="onNextClicked"><img src="@/assets/img/ic-arrow-right-circle.svg" alt="arrow-right"></div>
    </div>
  </div>
</template>

<script>
import previewApi from '@/api/preview.js'
import SectionHeader from '../SectionHeader.vue'
import ProductGridItem from './ProductGridItem.vue'

export default {
  name: 'PreviewHorizontalProductList',
  components: {
    SectionHeader,
    ProductGridItem
  },
  props: {
    id: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    productIds: {
      type: Array,
      default: null
    },
    viewAll: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      view: {
        scrollPercentage: 0
      },
      mouse: {
        active: false,
        domX: 0,
        cursorX: 0
      },
      products: null
    }
  },
  mounted: function () {
    this.apiGetProducts()
    if (this.id) {
      document.getElementById(this.id).addEventListener('scroll', this.onScroll)
    }
  },
  methods: {
    apiGetProducts: function () {
      if (!this.productIds) {
        return
      }
      var self = this
      this.products = new Array(this.productIds.length).fill(null)
      this.productIds.forEach((e, i) => {
        previewApi.getProduct(e, function (err, rspData) {
          if (err) {
            alert(`${err}: ${rspData}`)
            return
          }
          self.$set(self.products, i, rspData)
          self.$nextTick().then(() => {
            self.onScroll()
          })
        })
      })
    },
    onScroll: function () {
      var dom = document.getElementById(this.id)
      if (dom) {
        this.view.scrollPercentage = parseInt((dom.scrollLeft + dom.offsetWidth) * 100 / dom.scrollWidth)
      }
    },
    onPrevClicked: function () {
      var dom = document.getElementById(this.id)
      if (dom) {
        var domProductItems = dom.getElementsByClassName('product-item')
        var scrollWidth = 200
        if (domProductItems && domProductItems.length) {
          scrollWidth = domProductItems[0].scrollWidth
        }
        dom.scroll({ left: dom.scrollLeft - scrollWidth, behavior: 'smooth' })
      }
    },
    onNextClicked: function () {
      var dom = document.getElementById(this.id)
      if (dom) {
        var domProductItems = dom.getElementsByClassName('product-item')
        var scrollWidth = 200
        if (domProductItems && domProductItems.length) {
          scrollWidth = domProductItems[0].scrollWidth
        }
        dom.scroll({ left: dom.scrollLeft + scrollWidth, behavior: 'smooth' })
      }
    },
    onMouseDown: function (event) {
      var dom = document.getElementById(this.id)
      if (dom) {
        this.mouse.active = true
        this.mouse.domX = dom.scrollLeft
        this.mouse.cursorX = event.clientX
      }
    },
    onMouseUp: function (event) {
      this.mouse.active = false
      var dom = document.getElementById(this.id)
      if (dom) {
        var dragWidth = event.clientX - this.mouse.cursorX
        var domProductItems = dom.getElementsByClassName('product-item')
        if (domProductItems && domProductItems.length) {
          var itemWidth = domProductItems[0].scrollWidth
          dragWidth = itemWidth * Math.round(dragWidth / itemWidth)
        }
        dom.scroll({ left: this.mouse.domX - dragWidth, behavior: 'smooth' })
      }
    },
    onMouseMove: function (event) {
      if (!this.mouse.active) {
        return
      }
      var dom = document.getElementById(this.id)
      if (dom) {
        var dragWidth = event.clientX - this.mouse.cursorX
        dom.scroll({ left: this.mouse.domX - dragWidth, behavior: 'instant' })
      }
    }
  }
}
</script>

<style scoped>
.product-scroll {
  overflow-x: scroll;
  user-select: none;
}
.product-scroll::-webkit-scrollbar {
  -webkit-appearance: none;
  height: 4px;
}
::-webkit-scrollbar-track {
  background-color: white;
  display: none;
}
.product-scroll::-webkit-scrollbar-thumb {
  border-radius: 0px;
  background-color: black;
  display: none;
}
/*
.product-scroll-frame::after {
  background: linear-gradient(to right,rgba(255,255,255,0) 0,rgba(255,255,255,.75) 100%);
  bottom: 0;
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  width: 10vw;
}
*/
.product-scroll-frame:hover .btn-scroll {
  opacity: 1;
}
.btn-scroll {
  position: absolute;
  width: 60px;
  display: inline-block;
  cursor: pointer;
  opacity: 0;
  transition: opacity .2s ease;
  top: calc((100% - 90.4px) / 2 - 2rem);
  font-size: 2rem;
  z-index: 100;
}
.btn-scroll.left {
  left: 1rem;
}
.btn-scroll.right {
  right: 1rem;
}
/* hover effect
.btn-scroll i {
  transition: all .5s ease;
}
.btn-scroll.left:hover i, .btn-scroll.right:hover i {
  color: var(--bs-dark) !important;
}
*/
.percentage-scrollbar {
  height: 4px;
  transition: width .15s ease;
}

/* 與前台 HorizontalProductList 保持一致：項目寬度由版型決定，不被商品名稱撐開 */
.product-scroll .product-item {
  /* 項目含左右 gutter 各 0.75rem，加回來圖片才會剛好是原本的 18.5vw，大螢幕尺寸維持不變 */
  width: calc(18.5vw + 1.5rem);
  min-width: calc(200px + 1.5rem);  /* 對應原本 .image 的 min-width: 200px */
  vertical-align: top;
  white-space: normal;
}

@media screen and (max-width: 767px) {
  .product-scroll-frame::after {
    width: 30vw;
  }
  .product-scroll .product-item {
    width: calc(80vw + 1.5rem);
    min-width: 0;
  }
}
</style>
